import { useAuth } from "@/src/contexts/auth.context";
import { EventItem, RSVPStatus } from "@/src/models/event.model";
import {
  useGetAttendeeCountQuery,
  useGetUserRSVPQuery,
  useInsertRSVPMutation,
  useLeaveEventMutation,
} from "@/src/services/api/events/events.hooks";

export const useEventRSVP = (event: EventItem) => {
  const { user } = useAuth();
  const currentUserId = user?.itemId ?? "";

  const isRegistrationRequired = event.registrationPolicy === "Required";

  const { data: userRsvp } = useGetUserRSVPQuery(currentUserId, event.ItemId, {
    enabled: isRegistrationRequired,
  });
  const { data: attendeeCount = 0 } = useGetAttendeeCountQuery(event.ItemId, {
    enabled: isRegistrationRequired,
  });

  const isAttending =
    isRegistrationRequired && userRsvp?.status === RSVPStatus.GOING;
  const isWaitlisted =
    isRegistrationRequired && userRsvp?.status === RSVPStatus.WAITING;
  const isFull =
    isRegistrationRequired &&
    !!event.capacity &&
    attendeeCount >= event.capacity;

  const { mutate: insertRSVP, isPending: isJoining } = useInsertRSVPMutation();
  const { mutate: leaveEvent, isPending: isLeaving } = useLeaveEventMutation(
    event.ItemId,
    event.capacity,
  );

  const handleJoin = () => {
    insertRSVP({
      eventId: event.ItemId,
      status: isFull ? RSVPStatus.WAITING : RSVPStatus.GOING,
      eventParticipantSnapshot: {
        firstName: user?.firstName ?? "",
        lastName: user?.lastName ?? "",
        email: user?.email ?? "",
        profileImageUrl: user?.profileImageUrl ?? "",
      },
    });
  };

  const handleLeave = (rsvpItemId: string) => {
    leaveEvent({ itemId: rsvpItemId });
  };

  const joinButtonText = isAttending
    ? "BTN_LEAVE"
    : isWaitlisted
      ? "BTN_LEAVE_WAITLIST"
      : isFull
        ? "BTN_JOIN_WAITLIST"
        : "BTN_JOIN";

  return {
    userRsvp,
    attendeeCount,
    isAttending,
    isWaitlisted,
    isFull,
    isJoining,
    isLeaving,
    joinButtonText,
    handleJoin,
    handleLeave,
  };
};
